import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authApi } from '../services/api';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Login.css';

function ResendVerification() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Get email from URL params if available
  useEffect(() => {
    const emailFromUrl = searchParams.get('email');
    if (emailFromUrl) {
      setEmail(emailFromUrl);
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await authApi.resendVerification(email);
      
      if (response.data.success) {
        setSuccess(response.data.message || 'Verification code has been sent. Please check your inbox.');
        
        // In debug mode, show verification code if provided
        if (response.data.verification_code) {
          setSuccess(response.data.message + ' Verification Code: ' + response.data.verification_code);
        }
      } else {
        setError(response.data.message || 'Failed to send verification code.');
      }
    } catch (err) {
      setError(
        err.response?.data?.message || 
        'Failed to send verification code. Please try again later.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="container">
        <div className="login-page">
          <h1>Resend Verification Code</h1>
          
          <p style={{ marginBottom: '1.5rem', color: '#666' }}>
            Enter your email address and we'll send you a new 6-digit verification code.
          </p>

          {error && <div className="error-message">{error}</div>}
          {success && (
            <div className="alert alert-success" style={{ 
              padding: '1rem', 
              backgroundColor: '#d4edda', 
              border: '1px solid #c3e6cb', 
              borderRadius: '4px',
              color: '#155724',
              marginBottom: '1rem'
            }}>
              {success}
            </div>
          )}

          {!success && (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  disabled={loading}
                  placeholder="Enter your email address"
                />
              </div>

              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
                style={{ width: '100%' }}
              >
                {loading ? 'Sending...' : 'Send Verification Code'}
              </button>
            </form>
          )}

          <p className="register-link" style={{ marginTop: '1rem' }}>
            <Link to="/login">Back to Login</Link> | <Link to="/register">Register</Link>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ResendVerification;
